import { Grid } from "./SubpageGrid.css";
import { GridProps } from "interfaces";
export default function SubpageGrid({ children, marginTop }: GridProps) {
   return <Grid navOffset={marginTop}>{children}</Grid>;
}
